import axiosInstance from '../fetchConfig/axiosConfig';
import { toMySQLDateTime } from './helper_functions';
import logger from '../utils/logger';

// Simple function to complete case status tasks (the tracking info of cases as they move through pipeline)
export async function completeCaseStatus(parcelIds, reviewType, options = {}) {
  const {
    muniCode = 'All',
    taxYear,
    userId = null,
    updateAllExcept = false, // used for the data analysis generalized update in /dataAnalysis/apiUtils.js
    additionalFields = {}, // for any additional fields to update (like MiscDesc)
    userAccessLevel = null, // user's access level for permission checking
    villageRun = 0,
    completeAllCaseTypes = false, // DataCleaning: complete Town and Village rows when both exist
    onlyIfOpen = false, // data analysis auto-complete: open tasks only, leave assignee alone
  } = options;

  logger.log('🔍 [CASE_STATUS_UPDATER] Starting completeCaseStatus function');

  try {
    // Check if user is a training user and restrict review types
    if (userAccessLevel === 'Training') {
      const allowedReviewTypes = ['DataCleaning'];
      if (!allowedReviewTypes.includes(reviewType)) {
        logger.error('❌ [CASE_STATUS_UPDATER] Training user attempted invalid review type:', {
          userAccessLevel,
          reviewType,
          allowedReviewTypes
        });
        throw new Error(`Training users can only complete tasks for review types: ${allowedReviewTypes.join(', ')}. Attempted to complete: ${reviewType}`);
      }
      logger.log('✅ [CASE_STATUS_UPDATER] Training user validation passed');
    }
    // If the user is passing in specific records to update, force an overwrite.
    // The !== data cleaning is legacy, the force was previously set to true in this function, but its not right
    // for the datacleaning review type. This needs to be revisited in the future.
    const forceOverwrite = onlyIfOpen ? false : (!updateAllExcept || reviewType !== 'DataCleaning');

    const currentDateTime = toMySQLDateTime(new Date());
    const fieldsToUpdate = {
      DateCompleted: currentDateTime,
    };
    if (updateAllExcept) {
      fieldsToUpdate.assignee = null;
    } else if (!onlyIfOpen) {
      fieldsToUpdate.assignee = userId;
    }
    Object.assign(fieldsToUpdate, additionalFields);
    const updateParams = {
      MuniCode: muniCode,
      TaxYear: taxYear,
      reviewType: reviewType,
      uids: parcelIds,
      updateAllExcept: updateAllExcept,
      fieldsToUpdate,
      forceUpdateCompleted: forceOverwrite, // false means we only update non-completed tasks
      villageRun,
      completeAllCaseTypes,
    };

    logger.log('🔍 [CASE_STATUS_UPDATER] Prepared update parameters:', {
      ...updateParams,
      fieldsToUpdate: {
        ...updateParams.fieldsToUpdate,
        DateCompleted: currentDateTime
      },
      uidsCount: parcelIds?.length || 0,
      uidsSample: parcelIds?.slice(0, 3) // Show first 3 for debugging
    });

    logger.log('🔍 [CASE_STATUS_UPDATER] Making API call to /update_tasks_generalized');
    const updateResp = await axiosInstance.post('/update_tasks_generalized', updateParams);
    
    logger.log('✅ [CASE_STATUS_UPDATER] API call successful:', {
      status: updateResp.status,
      statusText: updateResp.statusText,
      dataKeys: Object.keys(updateResp.data || {}),
      responseData: updateResp.data
    });
    
    return updateResp.data;
  } catch (error) {
    logger.error('❌ [CASE_STATUS_UPDATER] Error completing case status:', {
      error: error.message,
      stack: error.stack,
      parcelIds: parcelIds?.length || 0,
      reviewType,
      muniCode,
      taxYear,
      userId,
      updateAllExcept
    });
    throw error;
  }
}
